import { createSlice } from '@reduxjs/toolkit';
import { initialState } from '../../../../data/entitlement/contracts/warrantyExtendedPeriod/initialState.warrantyPeriod.data';
import { v4 as uuidv4 } from 'uuid';
import {
  zoneTab,
  priceClassList,
} from '../../../../data/request/entitlement/contracts/extendedServicePeriod/extendedRequest.data';
import { createAsyncThunkWrapper } from '../../../../services/common/asyncThunkWrapper';
import {
  getPriceClassesServiceOfferingsData as getPriceClassesServiceOfferingsAPI,
  getDeferralPriceClassess as getDeferralPriceClassessAPI,
  extendedWarrentitySave as extendedWarrentitySaveAPI,
  getContractPriceClasses as getContractPriceClassesAPI,
  getPriceClassWithServices as getPriceClassWithServicesAPI,
  getContractServiceOfferings as getContractServiceOfferingsAPI,
  updateSelectedOptions as updateSelectedOptionsAPI,
  getContractBillSets as getContractBillSetsAPI,
  getContractBillCycles as getContractBillCyclesAPI,
  getDefaultPriceOptions as getDefaultPriceOptionsAPI,
  fetchContractsSearchById as fetchContractsSearchByIdAPI,
  getDeferralServiceOfferings as getDeferralServiceOfferingsAPI,
  getSelectedOptionsPriceClasses as getSelectedOptionsPriceClassesAPI,
  selectedOptionDefferalServiceOffering as selectedOptionDefferalServiceOfferingAPI,
  trickleDownContractChange as trickleDownContractChangeAPI,
  updatePriceClassOptionsTab as updatePriceClassOptionsTabAPI,
} from '../../../../apis/contractsAPI';
import {
  ACTIONS_CONTRACTS,
  ACTIONS_SLECTED_OPTIONS_TAB,
  ACTIONS_WARRANTITY_EXTENDED_SERVICES,
} from '../../../../constants/actionCreator';
import {
  COMMON_MESSAGE,
  CONTRACTS_DATA,
  PRICE_OPTIONS_DEFAULT_TAB,
  handlePending,
  handleRejection,
} from '../../../../constants';
import {
  calculatedFeeCalculation_onFactor,
  convertZoneToPriceClass,
  PCSelectionTab_PCOptionsTab_SaveData,
} from '../../../../utils/common';
// API Call Functions
export const getPriceClassesServiceOfferingsData = createAsyncThunkWrapper(
  ACTIONS_WARRANTITY_EXTENDED_SERVICES.FETCH_SERVICE_OFFERINGS,
  getPriceClassesServiceOfferingsAPI
);

export const getDeferralServiceOfferings = createAsyncThunkWrapper(
  ACTIONS_WARRANTITY_EXTENDED_SERVICES.FETCH_DEFERRAL_SERVICE_OFFERINGS,
  getDeferralServiceOfferingsAPI
);

export const getDeferralPriceClassess = createAsyncThunkWrapper(
  ACTIONS_WARRANTITY_EXTENDED_SERVICES.DEFERRAL_PRICE_CLASSES_SEARCH,
  getDeferralPriceClassessAPI
);

export const extendedWarrentitySave = createAsyncThunkWrapper(
  ACTIONS_WARRANTITY_EXTENDED_SERVICES.EXTENDED_WARRANTY_SAVE,
  extendedWarrentitySaveAPI
);

export const getContractPriceClasses = createAsyncThunkWrapper(
  ACTIONS_WARRANTITY_EXTENDED_SERVICES.GET_CONTRACT_PRICE_CLASSES,
  getContractPriceClassesAPI
);

export const getSelectedOptionsPriceClasses = createAsyncThunkWrapper(
  ACTIONS_WARRANTITY_EXTENDED_SERVICES.GET_SELECTED_OPTIONS_PRICE_CLASSES,
  getSelectedOptionsPriceClassesAPI
);

export const getPriceClassWithServices = createAsyncThunkWrapper(
  ACTIONS_WARRANTITY_EXTENDED_SERVICES.GET_CONTRACT_PRICE_CLASS_OPTION,
  getPriceClassWithServicesAPI
);

export const getContractServiceOfferings = createAsyncThunkWrapper(
  ACTIONS_WARRANTITY_EXTENDED_SERVICES.GET_CONTRACT_SERVICE_OFFERINGS,
  getContractServiceOfferingsAPI
);

export const getContractBillSets = createAsyncThunkWrapper(
  ACTIONS_SLECTED_OPTIONS_TAB.GET_CONTRACT_BILL_SETS,
  getContractBillSetsAPI
);

export const updateSelectedOptions = createAsyncThunkWrapper(
  ACTIONS_SLECTED_OPTIONS_TAB.UPDATE_SELECTED_OPTION,
  updateSelectedOptionsAPI
);

export const getContractBillCycles = createAsyncThunkWrapper(
  ACTIONS_SLECTED_OPTIONS_TAB.GET_CONTRCAT_EM_BILL_CYCLES,
  getContractBillCyclesAPI
);

export const getDefaultPriceOptions = createAsyncThunkWrapper(
  ACTIONS_SLECTED_OPTIONS_TAB.GET_CONTRCAT_DEFAULT_PRICE_OPTIONS,
  getDefaultPriceOptionsAPI
);

export const fetchContractsSearchById = createAsyncThunkWrapper(
  ACTIONS_CONTRACTS.FETCH_CONTRACTS_BY_ID,
  fetchContractsSearchByIdAPI
);

export const selectedOptionDefferalServiceOffering = createAsyncThunkWrapper(
  ACTIONS_WARRANTITY_EXTENDED_SERVICES.GET_DEFFARAL_SERVICE_OFFERING,
  selectedOptionDefferalServiceOfferingAPI
);

export const trickleDownContractChange = createAsyncThunkWrapper(
  ACTIONS_WARRANTITY_EXTENDED_SERVICES.PUT_TRICKLE_DOWN,
  trickleDownContractChangeAPI
);

export const updatePriceClassOptionsTab = createAsyncThunkWrapper(
  ACTIONS_WARRANTITY_EXTENDED_SERVICES.CONTRACTS_UPDATE_PRICECLASSES,
  updatePriceClassOptionsTabAPI
);

// Reducer and Actions
const warrantyPeriodSlice = createSlice({
  name: 'warrantyPeriod',
  initialState,
  reducers: {
    handleTrickleDownFlags: (state, action) => {
      state.trickleDownFields[action.payload.name] = action.payload.value;
    },
    handleIsTrickleDown: (state, action) => {
      state.isTrickleDownChecked = action.payload.value;
    },
    addPriceClassData: (state, action) => {
      state.isAddExistingPriceClass = action?.payload;
      state.priceClassesSearch = initialState.priceClassesSearch;
    },
    handleSetContractTabValue: (state, action) => {
      state.contractTabSelectedValue = action?.payload;
      if (action?.payload === 1 || action?.payload === 2) {
        state.selectedContractFeeTypeId = action?.payload;
      } else {
        state.selectedContractFeeTypeId = 0;
      }
    },
    //priceClassesSearch
    handlePriceClassessearch: (state, action) => {
      state.priceClassesSearch[action?.payload?.name] = action?.payload?.value;
    },
    //selected PriceClasses Row
    handleSelectedPriceClasses: (state, action) => {
      state.addNewPriceClassSelectedRow = action?.payload;
    },
    handleClosePriceClassAlreadyAdded: (state) => {
      state.priceClassAlreadyAdded = false;
      state.deferralPriceClassSearch = initialState.deferralPriceClassSearch;
    },

    handleAddDeferralPriceClass: (state, action) => {
      const transformPriceClasses = (data) => {
        return data?.map((item) => ({
          id: uuidv4(),
          contractId: 0,
          priceClassId: item.price_Class_Id,
          name: item.name,
          priceClassName: item.name,
          lastModifiedUserId: item.last_Modified_User_Id,
          lastModifiedTimestamp: item.last_Modified_TimeStamp,
          isDeleted: false,
          isInserted: true,
          isInsertedOnUI: true,
          contractZoneId: 1,
          deferralServiceOfferingId: null,
          deferralServiceOfferingAddonId: null,
          extendedServicesDurationDays: 0,
          effectiveDate: new Date(),
          serviceOfferingList: [],
          prepaymentFlag: 'n',
          prepaymentDurationDays: 0,
          autoRenewFlag: 'n',
          factor: 1,
        }));
      };
      let convertToSaveFormat = transformPriceClasses(
        action?.payload ? action?.payload : []
      );
      let alreadyAddedPriceClasses = [];
      state.warrantyPeriodTabData[
        state.selectedPriceOptionTab
      ]?.priceClassList?.map((item) => {
        alreadyAddedPriceClasses.push(item?.priceClassId);
      });
      const addPriceClasByZone = (item) => {
        let copyData;
        copyData = structuredClone(convertToSaveFormat[0]);
        if (!alreadyAddedPriceClasses?.includes(copyData?.priceClassId)) {
          copyData['contractZoneId'] = item?.contractZoneId;
          copyData['contractId'] = state.contractId;
          item['priceClassList'].unshift(copyData);
          state.isDataToSave.push(copyData?.priceClassId);
        } else {
          let showAlert = true;
          item.priceClassList.map((priceCl) => {
            if (
              priceCl?.priceClassId === convertToSaveFormat[0]?.priceClassId &&
              priceCl?.isDeleted
            ) {
              priceCl['isDeleted'] = false;
              showAlert = false;
              const index = state.isDataToSave.indexOf(
                convertToSaveFormat[0]?.priceClassId
              );
              if (index > -1) {
                let filterData = state.isDataToSave.filter((item) => {
                  if (item === convertToSaveFormat[0]?.priceClassId) {
                    return false;
                  }
                  return item;
                });
                state.isDataToSave = filterData;
              }
            }
            return priceCl;
          });
          state.priceClassAlreadyAdded = showAlert;
        }
        return item;
      };
      const mydata = JSON.parse(JSON.stringify(state.warrantyPeriodTabData));
      if (
        state.selectedZoneId === CONTRACTS_DATA.extendedWarrentity.rentalZoneId
      ) {
        //IF ZONE IS RENTAL
        state.warrantyPeriodTabData = mydata?.map((item) => {
          if (
            item?.contractZoneId ===
            CONTRACTS_DATA.extendedWarrentity.rentalZoneId
          ) {
            return addPriceClasByZone(item);
          }
          return item;
        });
        if (
          !alreadyAddedPriceClasses.includes(
            convertToSaveFormat[0]?.priceClassId
          )
        ) {
          state.rentalPriceClassAdded = convertToSaveFormat[0].id;
        }
      } else {
        //ELSE ZONE IS NON RENTAL
        state.warrantyPeriodTabData = mydata?.map((item) => {
          if (
            item?.contractZoneId !==
            CONTRACTS_DATA.extendedWarrentity.rentalZoneId
          ) {
            return addPriceClasByZone(item);
          } else {
            return item;
          }
        });
        if (
          !alreadyAddedPriceClasses.includes(
            convertToSaveFormat[0]?.priceClassId
          )
        ) {
          state.nonRentalPriceClassAdded = convertToSaveFormat[0];
        }
      }
      state.deferralPriceClassSearch = initialState.deferralPriceClassSearch;
    },

    handleRemoveDeferralPriceClass: (state, action) => {
      const mydata = JSON.parse(JSON.stringify(state.warrantyPeriodTabData));
      const removePriceClasByZone = (item) => {
        let newItem;
        if (action?.payload?.isInsertedOnUI) {
          newItem = item?.priceClassList?.filter((priceClass) => {
            if (
              priceClass?.priceClassId !== action?.payload?.priceClassId &&
              action?.payload?.isInsertedOnUI
            ) {
              return priceClass;
            }
          });
        } else {
          newItem = item?.priceClassList?.map((priceClass) => {
            if (priceClass?.priceClassId === action?.payload?.priceClassId) {
              priceClass.isDeleted = true;
            }
            return priceClass;
          });
        }
        item['priceClassList'] = newItem;
        return item;
      };
      if (
        CONTRACTS_DATA.extendedWarrentity.rentalZoneId === state.selectedZoneId
      ) {
        state.warrantyPeriodTabData = mydata?.map((item) => {
          if (
            item?.contractZoneId ===
            CONTRACTS_DATA.extendedWarrentity.rentalZoneId
          ) {
            return removePriceClasByZone(item);
          }
          return item;
        });
      } else {
        state.warrantyPeriodTabData = mydata?.map((item) => {
          if (
            item?.contractZoneId !==
            CONTRACTS_DATA.extendedWarrentity.rentalZoneId
          ) {
            return removePriceClasByZone(item);
          }
          return item;
        });
      }
    },

    handleSelectedPriclassesData: (state, action) => {
      state.priceClassesName = action?.payload?.name;
      state.zoneselectedPriceClass = action?.payload;
      state.nonRentalPriceClassAdded = initialState.nonRentalPriceClassAdded;
      state.rentalPriceClassAdded = initialState.rentalPriceClassAdded;
      state.warrantyPeriodTabData?.forEach((item) => {
        if (item?.contractZoneId === state.selectedZoneId) {
          item.lastSelectedPriceClassId = action?.payload?.priceClassId;
        }
      });
    },

    handleSetAnnualFeeService: (state, action) => {
      state.warrantyPeriodTabData?.map((item) => {
        if (item?.contractZoneId === state.selectedZoneId) {
          item?.priceClassList?.map((el) => {
            if (
              el.priceClassId === state.zoneselectedPriceClass?.priceClassId
            ) {
              el.serviceOfferingList = action?.payload;
            }
            return el;
          });
        }
        return item;
      });
    },

    handleRentalAnnualFeeAdd: (state, action) => {
      state.contractRentalServiceOfferings = action?.payload;
    },
    handleManualContractData: (state, action) => {
      state.contractData = action?.payload;
    },
    handleDeferralPriceclassAlert: (state, action) => {
      state.deferralPriceClassAlert = action?.payload;
      if (action?.payload) {
        state.deferralPriceClassSearch = null;
      }
    },
    handleSelectedPriceOptions: (state, action) => {
      let updateValue = state.selectedOptions_PriceClassesData;
      state.s_O_P_C_Datafound = false;
      if (action?.payload?.priceClass) {
        const notFoundPriceClass =
          state.selectedOptions_PriceClassesData.find(
            (pc) =>
              pc.priceClassId ===
              action?.payload?.priceClass?.contractPriceClass?.price_Class_Id
          ) || null;
        state.selectedOptions_PriceClassesData = updateValue?.map((item, i) => {
          if (notFoundPriceClass === null && i === 0) {
            item.selectedPC = true;
            state.selectedPriceClassData = item;
            state.selectedPCIndex = i;
            state.selectedPCDeleted = true;
          } else if (
            notFoundPriceClass !== null &&
            item?.contractPriceClass?.price_Class_Id ===
              action?.payload?.priceClass?.contractPriceClass?.price_Class_Id
          ) {
            item.selectedPC = true;
            state.selectedPriceClassData = item;
            state.selectedPCIndex = i;
          } else {
            item.selectedPC = false;
          }
          return item;
        });
      } else {
        state.selectedOptions_PriceClassesData = updateValue?.map((item, i) => {
          if (i === 0) {
            item.selectedPC = true;
            state.selectedPriceClassData = item;
            state.selectedPCIndex = i;
            state.selectedPCDeleted = true;
          }
          return item;
        });
      }
    },
    handleContractDetailsForm: (state, action) => {
      state.selectedOtionsUpdateData[action?.payload?.name] =
        action?.payload?.value;
      state.contractData.description = action?.payload?.value;
    },
    handleSlectedOptionsForm: (state, action) => {
      state.selectedOtionsUpdateData.general[action?.payload?.name] =
        action?.payload?.value;
      state.selectedOtionsUpdateData.isGeneralDataChanged = true;
    },
    handleBillingForm: (state, action) => {
      state.selectedOtionsUpdateData.billing.billingGeneral[
        action?.payload?.name
      ] = action?.payload?.value;
      state.selectedOtionsUpdateData.billing.isBillingGeneralDataChanged = true;
      state.selectedOtionsUpdateData.isBillingDataChanged = true;
    },
    handleOosForm: (state, action) => {
      state.selectedOtionsUpdateData.billing.oos[action?.payload?.name] =
        action?.payload?.value;
      state.selectedOtionsUpdateData.billing.isOosDataChanged = true;
      state.selectedOtionsUpdateData.isBillingDataChanged = true;
    },
    handleCpiForm: (state, action) => {
      state.selectedOtionsUpdateData.billing.cpi[action?.payload?.name] =
        action?.payload?.value;
      state.selectedOtionsUpdateData.billing.isCpiDataChanged = true;
      state.selectedOtionsUpdateData.isBillingDataChanged = true;
    },

    handleWarrantyForm: (state, action) => {
      state.selectedOtionsUpdateData.warranty[action?.payload?.name] =
        action?.payload?.value;
      state.selectedOtionsUpdateData.isWarrantyDataChanged = true;
    },
    handleEtrackForm: (state, action) => {
      state.selectedOtionsUpdateData.etrack[action?.payload?.name] =
        action?.payload?.value;
      state.selectedOtionsUpdateData.isEtrackDataChanged = true;
    },
    handleSlectedOptionsExistingData: (state) => {
      let general = state.selectedOtionsUpdateData?.general;
      let billingGeneral =
        state.selectedOtionsUpdateData?.billing?.billingGeneral;
      let cpi = state.selectedOtionsUpdateData?.billing?.cpi;
      let oos = state.selectedOtionsUpdateData?.billing?.oos;
      let warranty = state.selectedOtionsUpdateData?.warranty;
      let etrack = state.selectedOtionsUpdateData?.etrack;

      if (state.contractData?.length > 0) {
        general = initialState.selectedOtionsUpdateData.general;
        billingGeneral =
          initialState.selectedOtionsUpdateData.billing.billingGeneral;
        oos = initialState.selectedOtionsUpdateData.billing.oos;
        cpi = initialState.selectedOtionsUpdateData.cpi;
        warranty = initialState.selectedOtionsUpdateData.warranty;
        etrack = initialState.selectedOtionsUpdateData.etrack;
      }
      state.selectedOtionsUpdateData.contractStatus =
        state.contractData?.contractStatus;
      state.selectedOtionsUpdateData.shortName = state.contractData?.shortName;
      state.selectedOtionsUpdateData.description =
        state.contractData?.description;
      general.syncContractId = state.contractData?.syncContractId;
      general.retailPercentage = state.contractData?.retailPercentage;
      general.retailPercentageFlag = state.contractData?.retailPercentageFlag;
      general.transferHwDeactivateFlag =
        state.contractData?.transferHwDeactivateFlag;
      general.contractStartDate = state.contractData?.contractStartDate
        ? state.contractData?.contractStartDate
        : state.contractData?.createdOnDate;
      general.contractStartDateSAVE = state.contractData?.contractStartDate
        ? state.contractData?.contractStartDate
        : state.contractData?.createdOnDate;
      general.contractEndDate = state.contractData?.contractEndDate;
      general.contractEndDateSAVE = state.contractData?.contractEndDate;
      general.defaultZoneId = state.contractData?.defaultZoneId;
      general.currentDefaultZoneName = state.contractData?.defaultZoneName;
      general.previousDefaultZoneName = state.contractData?.defaultZoneName;
      general.deferralCountryId = state.contractData?.deferralCountryId;
      general.currentDeferralCountryName =
        state.contractData?.deferralCountryName;
      general.previousDeferralCountryName =
        state.contractData?.deferralCountryName;
      general.currentFreightFwdCountryName =
        state.contractData?.freightFwdCountryName;
      general.previousFrightFwdCountryName =
        state.contractData?.freightFwdCountryName;
      billingGeneral.cycleId = state.contractData?.billCycleId;
      billingGeneral.currentCycleName = state.contractData?.billCycleName;
      billingGeneral.previousCycleName = state.contractData?.billCycleName;
      billingGeneral.currencyId = state.contractData?.currencyId;
      billingGeneral.currentCurrencyName = state.contractData?.currencyName;
      billingGeneral.previousCurrencyName = state.contractData?.currencyName;
      billingGeneral.daysOut = state.contractData?.daysOut;
      billingGeneral.exceptionFlag = state.contractData?.exceptionFlag;
      billingGeneral.exceptionNote = state.contractData?.exceptionNote;
      billingGeneral.prepaymentDays = state.contractData?.prepaymentDays;
      billingGeneral.autoBillFlag = state.contractData?.autoBillFlag;
      oos.billSupportFlag = state.contractData?.oosBillSupportFlag;
      oos.nonStandardFeeFlag = state.contractData?.oosNonStandardFeeFlag;
      oos.billSetId = state.contractData?.billSetId;
      oos.currentBillSetName = state.contractData?.billSetName;
      oos.previousBillSetName = state.contractData?.billSetName;
      cpi.eligibleFlag = state.contractData?.cpiElligibleFlag;
      cpi.maxValue = state.contractData?.cpiMaxValue;
      cpi.minValue = state.contractData?.cpiMinValue;
      warranty.newDuration = state.contractData?.warrantyNewDuration;
      warranty.standardDuration =
        state.contractData?.warrantyStandardDurationDays;
      warranty.installDelayDays = state.contractData?.warrantyInstallDelayDays;
      warranty.autoInstallFlag = state.contractData?.autoInstallFlag;
      warranty.standarDeferralFlag = state.contractData?.standardDeferralFlag;
      etrack.accessFlag = state.contractData?.etrackAccessFlag;
      etrack.importLimitYears = state.contractData?.etrackImportLimitYears;
      etrack.searchLimitYears = state.contractData?.etrackSearchLimitYears;
      state.selectedOtionsUpdateData.isGeneralDataChanged = false;
      state.selectedOtionsUpdateData.isBillingDataChanged = false;
      state.selectedOtionsUpdateData.isWarrantyDataChanged = false;
      state.selectedOtionsUpdateData.isEtrackDataChanged = false;
    },
    resetIsEditedSelectedOption: (state) => {
      state.selectedOtionsUpdateData.isGeneralDataChanged = false;
      state.selectedOtionsUpdateData.isBillingDataChanged = false;
      state.selectedOtionsUpdateData.isWarrantyDataChanged = false;
      state.selectedOtionsUpdateData.isEtrackDataChanged = false;
      state.isSelectedOptionsSaveSuccesfully =
        initialState.isSelectedOptionsSaveSuccesfully;
      state.apiSuccessResponse = initialState.apiSuccessResponse;
      state.isExtendedAPISuccess = initialState.isExtendedAPISuccess;
      state.isPriceClassOptionsChanged = false;
      state.isPriceClassSelectionChanged = false;
      state.selectedOptions_PriceClassesData.map((item) => {
        item.priceClassSelectionTab = [];
      });
      state.priceClassOptionsToSave = [];
    },
    handleContractStartDateChange: (state, action) => {
      state.selectedOtionsUpdateData.general.contractStartDate =
        action?.payload?.localTime;
      state.selectedOtionsUpdateData.general.contractStartDateSAVE =
        action?.payload?.localToUTCDate;
      state.selectedOtionsUpdateData.isGeneralDataChanged = true;
    },
    handleContractEndDateChange: (state, action) => {
      state.selectedOtionsUpdateData.general.contractEndDate =
        action?.payload?.localTime;
      state.selectedOtionsUpdateData.general.contractEndDateSAVE =
        action?.payload?.localToUTCDate;
      state.selectedOtionsUpdateData.isGeneralDataChanged = true;
    },
    handleResetValues: (state) => {
      state.addNewPriceClassSelectedRow =
        initialState.addNewPriceClassSelectedRow;
      state.apiSuccessResponse.update = initialState.apiSuccessResponse.update;
    },
    handleContractSaveClose: (state, action) => {
      state.isSelectedOptionsSave = action?.payload;
    },
    setAPIResponse: (state, action) => {
      state.apiSuccessResponse.update = action?.payload || null;
    },
    handleWarr_ExSer_APIResponse: (state, action) => {
      state.isExtendedAPISuccess = initialState.isExtendedAPISuccess;
    },
    handleOnAlertSave: (state, action) => {
      state.onAlertSave = action.payload;
    },
    handleChangeClick: (state, action) => {
      state.isHandleChange = action?.payload;
    },

    handleSetSelectedPriceOptionTab: (state, action) => {
      state.selectedZoneId = action?.payload?.selectedZoneId;
      state.selectedPriceOptionTab = action?.payload?.selectedPriceOptionTab;
      state.nonRentalPriceClassAdded = initialState.nonRentalPriceClassAdded;
      state.rentalPriceClassAdded = initialState.rentalPriceClassAdded;
    },
    handleAddNewPriceOption: (state, action) => {
      state.warrantyPeriodTabData.push(action?.payload);
    },
    selectedServiceOffering: (state, action) => {
      let updateValue = state.selectedOptions_PriceClassesData;
      state.selectedOptions_PriceClassesData = updateValue.map(
        (item, index) => {
          if (index === action.payload.priceClassIndex) {
            item.priceClassSelectionTab?.map((row) => {
              if (row?.unId === action?.payload?.rowData?.unId) {
                let selectedIndex = row.services.findIndex(
                  (sItem) =>
                    sItem.serviceOfferingId ===
                    action?.payload?.selectedServiceOffering[0]
                      ?.serviceOfferingId
                );
                row.selectedServiceOfferingIndex =
                  selectedIndex !== -1 ? selectedIndex : 0;
                row.selectedServiceOfferingId =
                  action?.payload?.selectedServiceOffering[0]?.serviceOfferingId;
                row.serviceOfferingId =
                  action?.payload?.selectedServiceOffering[0]?.serviceOfferingId;
                row.serviceOfferingName = row?.old_serviceOfferingName;
                row.newServiceOfferingName =
                  action?.payload?.selectedServiceOffering[0]?.serviceOfferingName;
                if (
                  row?.old_selectedServiceOfferingId !==
                  action?.payload?.selectedServiceOffering[0]?.serviceOfferingId
                ) {
                  row.isChanged = true;
                } else {
                  row.isChanged = false;
                }
              }
              return row;
            });
            state.selectedPriceClassData = item;
          }
          return item;
        }
      );
      let isSOChangedArray = [];
      state.selectedOptions_PriceClassesData.map((item) => {
        isSOChangedArray = [];
        item?.priceClassSelectionTab?.forEach((item) => {
          if (
            item?.old_selectedServiceOfferingId !==
            item?.selectedServiceOfferingId
          ) {
            isSOChangedArray.push(true);
          } else {
            isSOChangedArray.push(false);
          }
        });
        item.isChanged = isSOChangedArray.includes(true);
        return item;
      });
      state.isPriceClassSelectionChanged =
        state.selectedOptions_PriceClassesData
          ?.filter((item) => item?.isChanged)
          ?.map((item) => item?.isChanged)?.length > 0;
      const localData = JSON.parse(
        JSON.stringify(state.selectedOptions_PriceClassesData)
      );
      state.priceClassOptionsToSave = PCSelectionTab_PCOptionsTab_SaveData(
        localData,
        state.selectedOpDefServiceOffering,
        action?.payload?.loggedInUser
      );
    },
    handleIsDataToSave: (state, action) => {
      if (action?.payload.action === 'clear') {
        state.isDataToSave = initialState.isDataToSave;
      } else if (action?.payload.action === 'remove') {
        const index = state.isDataToSave.indexOf(action?.payload.value);
        if (index > -1) {
          let filterData = state.isDataToSave.filter((item) => {
            if (item === action?.payload.value) {
              return false;
            }
            return item;
          });
          state.isDataToSave = filterData;
        }
      } else {
        state.isDataToSave.push(action?.payload.value);
      }
    },

    handleReset_PC_and_SO_WP_ES_Tab: (state) => {
      state.existingContractPriceClasses =
        initialState.existingContractPriceClasses;
      state.zoneselectedPriceClass = initialState.zoneselectedPriceClass;
      const mydata = JSON.parse(JSON.stringify(state.warrantyPeriodTabData));
      state.warrantyPeriodTabData = mydata.map((tab) => {
        tab.priceClassList = [];
        tab.lastSelectedPriceClassId = 0;
        return tab;
      });
    },

    handleSetSaveAndClose: (state, action) => {
      state.isSaveAndClose = action?.payload;
    },

    handleSetContractId: (state, action) => {
      state.contractId = action?.payload;
    },

    handleSelectedPC: (state) => {
      state.selectedPriceClassData = initialState.selectedPriceClassData;
    },

    handleSelectedPCDeleted: (state) => {
      state.selectedPCDeleted = initialState.selectedPCDeleted;
    },

    handleResetSelectedOptionTab: (state) => {
      state.selectedPCIndex = initialState.selectedPCIndex;
      state.selectedOptions_PriceClassSelection =
        initialState.selectedOptions_PriceClassSelection;
      state.selectedPriceClassData = initialState.selectedPriceClassData;
      state.deferralPriceClassSearch = initialState.deferralPriceClassSearch;
      state.warrantyPeriodTabData = initialState.warrantyPeriodTabData;
      state.selectedZoneId = initialState.selectedZoneId;
      state.selectedPriceOptionTab = initialState.selectedPriceOptionTab;
      state.isPriceOptionsLoading = initialState.isPriceOptionsLoading;
      state.servicingOfferingLoading = initialState.servicingOfferingLoading;
      state.deferralPriceClassLoading = initialState.deferralPriceClassLoading;
      state.defaultPriceOptions = initialState.defaultPriceOptions;
      state.zoneselectedPriceClass = initialState.zoneselectedPriceClass;
      state.contractServiceOfferings = initialState.contractServiceOfferings;
      state.contractSearchServiceOfferings =
        initialState.contractSearchServiceOfferings;
      state.existingContractPriceClasses =
        initialState.existingContractPriceClasses;
      state.isDataToSave = initialState.isDataToSave;
      state.priceClassLoading = initialState.priceClassLoading;
      state.deferralServicingOfferingLoading =
        initialState.deferralServicingOfferingLoading;
      state.deferralServiceOfferings = initialState.deferralServiceOfferings;
      state.deferralPriceClasses = initialState.deferralPriceClasses;
      state.extendedWarraySaveLoading = initialState.extendedWarraySaveLoading;
      state.priceClassAlreadyAdded = initialState.priceClassAlreadyAdded;
      state.isSaveAndClose = initialState.isSaveAndClose;
      state.contractId = initialState.contractId;
      state.apiSuccessResponse = initialState.apiSuccessResponse;
      state.selectedOptions_PriceClassesData =
        initialState.selectedOptions_PriceClassesData;
      state.contractData = initialState.contractData;
      state.selectedOtionsUpdateData = initialState.selectedOtionsUpdateData;
      state.selectedOptionAlert = initialState.selectedOptionAlert;
      state.selectedOptionAlertText = initialState.selectedOptionAlertText;
      state.isSelectedOptionsSaveSuccesfully =
        initialState.isSelectedOptionsSaveSuccesfully;
      state.trickleDownFields = initialState.trickleDownFields;
      state.isTrickleDownChecked = initialState.isTrickleDownChecked;
      state.submitForApprovalSaveLoader =
        initialState.submitForApprovalSaveLoader;
      state.trickleDownAPIResponse = initialState.trickleDownAPIResponse;
      state.trickleDownLoading = initialState.trickleDownLoading;
      state.isTDSuccess = initialState.isTDSuccess;
    },
    handleSelectedOptionAlertText: (state, action) => {
      state.selectedOptionAlertText = action?.payload;
    },
    handleSelectedOptionAlert: (state, action) => {
      state.selectedOptionAlert = action?.payload;
    },
    handleUpdateContracData: (state, action) => {
      state.contractData.contractStatus = action?.payload?.contractStatus;
      state.selectedOtionsUpdateData.contractStatus =
        action?.payload?.contractStatus;
    },
    handleReadyForApproveOnClose: (state, action) => {
      if (
        state.selectedOtionsUpdateData.contractStatus ===
        CONTRACTS_DATA.statusModify
      ) {
        state.readyForApproveOnClose = action.payload;
      } else {
        state.readyForApproveOnClose = false;
      }
    },
    handleUpdatePCOptions: (state, action) => {
      let updateValue = state.selectedOptions_PriceClassesData;
      state.selectedOptions_PriceClassesData = updateValue.map((item) => {
        if (
          item.contractPriceClass.price_Class_Id ===
          action.payload.price_Class_Id
        ) {
          item.contractPriceClass[action.payload.fieldName] =
            action.payload.fieldValue;
          if (
            action.payload.fieldValue === COMMON_MESSAGE.no &&
            action.payload.fieldName === 'prepayment_Flag'
          ) {
            item.contractPriceClass.prepayment_Duration_Months = 0;
          } else if (
            action.payload.fieldValue === COMMON_MESSAGE.yes &&
            action.payload.fieldName === 'prepayment_Flag'
          ) {
            item.contractPriceClass.prepayment_Duration_Months = 1;
          }
          if (action.payload.date) {
            item.contractPriceClass.effective_Date_To_Save =
              action.payload.fieldValueToSave;
          }
          if (
            item?.contractPriceClass?.old_prepayment_Flag !==
              item?.contractPriceClass?.prepayment_Flag ||
            item?.contractPriceClass?.old_prepayment_Duration_Months !==
              item?.contractPriceClass?.prepayment_Duration_Months ||
            item?.contractPriceClass?.old_auto_Renew_Flag !==
              item?.contractPriceClass?.auto_Renew_Flag ||
            item?.contractPriceClass?.old_extended_Services_Duration_Months !==
              item?.contractPriceClass?.extended_Services_Duration_Months ||
            item?.contractPriceClass?.old_effective_Date !==
              item?.contractPriceClass?.effective_Date ||
            item?.contractPriceClass?.old_deferral_Service_Offering_Id !==
              item?.contractPriceClass?.deferral_Service_Offering_Id
          ) {
            item.isChanged = true;
          } else {
            item.isChanged = false;
          }
          state.selectedPriceClassData = item;
        }
        return item;
      });
      state.isPriceClassOptionsChanged =
        state.selectedOptions_PriceClassesData
          .filter((item) => item.isChanged)
          .map((item) => item.isChanged)?.length > 0;
      const localData = JSON.parse(
        JSON.stringify(state.selectedOptions_PriceClassesData)
      );
      state.priceClassOptionsToSave = PCSelectionTab_PCOptionsTab_SaveData(
        localData,
        state.selectedOpDefServiceOffering,
        action?.payload?.loggedInUser
      );
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPriceClassesServiceOfferingsData.pending, (state) => {
        state.servicingOfferingLoading = true;
        state.soCount = 0;
      })
      .addCase(
        getPriceClassesServiceOfferingsData.fulfilled,
        (state, action) => {
          let lastModifiedUserId = action?.meta?.arg?.lastModifiedUserId;
          let localSelectedZoneId = action?.meta?.arg?.contractZoneId;
          let localSelectedPriceClassId = action?.meta?.arg?.priceClassId;
          let factor = action?.meta?.arg?.factor || 1;
          state.servicingOfferingLoading = false;
          state.contractSearchServiceOfferings = action?.payload;
          state.soCount = action?.payload?.length || 0;
          const mappedServiceOfferings =
            state.contractSearchServiceOfferings?.map((serviceItem) => ({
              ...serviceItem,
              unId: uuidv4(),
              firstModifiedTimestamp: new Date(),
              firstModifiedUserId: serviceItem?.annualFee === null ? lastModifiedUserId : null,
              lastModifiedTimestamp: new Date(),
              lastModifiedUserId: lastModifiedUserId,
              isInserted:
                serviceItem?.serviceOfferingId ===
                  CONTRACTS_DATA.extendedWarrentity
                    .serviceOffering_5X9_NBD_PO &&
                localSelectedZoneId !==
                  CONTRACTS_DATA.extendedWarrentity.rentalZoneId &&
                (serviceItem?.annualFee === null ||
                  serviceItem?.annualFee === '')
                  ? true
                  : false,
              isUpdated: false,
              isDeleted: false,
              factor: factor || 1,
              so5X9_NBD_PO_annualFee: serviceItem?.annualFee,
              old_annualFee:
                serviceItem?.serviceOfferingId ===
                  CONTRACTS_DATA.extendedWarrentity
                    .serviceOffering_5X9_NBD_PO &&
                localSelectedZoneId !==
                  CONTRACTS_DATA.extendedWarrentity.rentalZoneId &&
                (serviceItem?.annualFee === null ||
                  serviceItem?.annualFee === '')
                  ? 0
                  : serviceItem?.annualFee,
              annualFee:
                serviceItem?.serviceOfferingId ===
                  CONTRACTS_DATA.extendedWarrentity
                    .serviceOffering_5X9_NBD_PO &&
                localSelectedZoneId !==
                  CONTRACTS_DATA.extendedWarrentity.rentalZoneId &&
                (serviceItem?.annualFee === null ||
                  serviceItem?.annualFee === '')
                  ? 0
                  : serviceItem?.annualFee,
              calculatedFee:
                serviceItem?.annualFee !== null
                  ? calculatedFeeCalculation_onFactor(
                      serviceItem?.annualFee,
                      factor
                    )
                  : serviceItem?.serviceOfferingId ===
                      CONTRACTS_DATA.extendedWarrentity
                        .serviceOffering_5X9_NBD_PO &&
                    localSelectedZoneId !==
                      CONTRACTS_DATA.extendedWarrentity.rentalZoneId
                  ? '0'
                  : null,
              canEdit: serviceItem?.annualFee === null ? false : true,
            }));
          let unId =
            mappedServiceOfferings?.find(
              (so) =>
                so?.serviceOfferingId ===
                  CONTRACTS_DATA.extendedWarrentity
                    .serviceOffering_5X9_NBD_PO &&
                localSelectedZoneId !==
                  CONTRACTS_DATA.extendedWarrentity.rentalZoneId
            ) || [];
          if (
            unId?.so5X9_NBD_PO_annualFee === null ||
            unId?.so5X9_NBD_PO_annualFee === ''
          ) {
            state.isDataToSave.push(unId?.unId);
          }
          state.contractServiceOfferings = mappedServiceOfferings;
          state.warrantyPeriodTabData?.map((item) => {
            if (item?.contractZoneId === localSelectedZoneId) {
              item?.priceClassList?.map((el) => {
                if (el?.priceClassId === localSelectedPriceClassId) {
                  if (
                    !el?.serviceOfferingList ||
                    el?.serviceOfferingList?.length === 0
                  ) {
                    el['serviceOfferingList'] = mappedServiceOfferings;
                  }
                }
                return el;
              });
            }
            return item;
          });
        }
      )
      .addCase(getPriceClassesServiceOfferingsData.rejected, (state) => {
        state.servicingOfferingLoading = false;
        state.soCount = 0;
      })

      .addCase(getDeferralServiceOfferings.pending, (state) => {
        state.deferralServicingOfferingLoading = true;
        state.soDeferralCount = 0;
      })
      .addCase(getDeferralServiceOfferings.fulfilled, (state, action) => {
        let lastModifiedUserId = action?.meta?.arg?.lastModifiedUserId;
        let localSelectedZoneId = action?.meta?.arg?.contractZoneId;
        let localSelectedPriceClassId = action?.meta?.arg?.priceClassId;
        state.deferralServicingOfferingLoading = false;
        const serviceOffering = action?.payload;
        state.soDeferralCount = action?.payload?.length || 0;
        const mappedServiceOfferings = serviceOffering?.map((serviceItem) => ({
          ...serviceItem,
          unId: uuidv4(),
          firstModifiedTimestamp: new Date(),
          lastModifiedTimestamp: new Date(),
          lastModifiedUserId: lastModifiedUserId,
          firstModifiedUserId: serviceItem?.annualFee === null ? lastModifiedUserId : null,
          isInserted: false,
          isUpdated: false,
          isDeleted: false,
          old_annualFee: serviceItem?.annualFee,
          old_durationMonths: serviceItem?.durationMonths,
          old_additionalFee: serviceItem?.additionalFee,
          contractFeeTypeId: state.selectedContractFeeTypeId,
          canEdit: serviceItem?.annualFee === null ? false : true,
          contractZoneId: localSelectedZoneId,
        }));
        state.deferralServiceOfferings = mappedServiceOfferings;
        state.warrantyPeriodTabData?.map((item) => {
          if (item?.contractZoneId === localSelectedZoneId) {
            item.priceClassList?.map((el) => {
              if (el?.priceClassId === localSelectedPriceClassId) {
                if (
                  !el?.serviceOfferingList ||
                  el?.serviceOfferingList?.length === 0
                ) {
                  el.serviceOfferingList = mappedServiceOfferings;
                }
              }
              return el;
            });
          }
          return item;
        });
      })
      .addCase(getDeferralServiceOfferings.rejected, (state) => {
        state.servicingOfferingLoading = false;
        state.soDeferralCount = 0;
      })

      .addCase(getDeferralPriceClassess.pending, (state) => {
        state.deferralPriceClassSearch = initialState.deferralPriceClassSearch;
        state.deferralPriceClassLoading = true;
      })
      .addCase(getDeferralPriceClassess.fulfilled, (state, action) => {
        state.deferralPriceClassSearch = action?.payload || [];
        state.deferralPriceClassLoading = false;
      })
      .addCase(getDeferralPriceClassess.rejected, (state) => {
        state.deferralPriceClassSearch = [];
        state.deferralPriceClassLoading = false;
      })

      .addCase(extendedWarrentitySave.pending, (state) => {
        state.extendedWarraySaveLoading = true;
        state.isExtendedAPISuccess = initialState.isExtendedAPISuccess;
      })
      .addCase(extendedWarrentitySave.fulfilled, (state, action) => {
        state.extendedWarraySaveLoading = false;
        state.isExtendedAPISuccess = true;
        state.isDataToSave = [];
      })
      .addCase(extendedWarrentitySave.rejected, (state) => {
        state.extendedWarraySaveLoading = false;
        state.isExtendedAPISuccess = false;
      })

      .addCase(getContractPriceClasses.pending, (state) => {
        state.priceClassLoading = true;
      })
      .addCase(getContractPriceClasses.fulfilled, (state, action) => {
        let localSelectedZoneId = action?.meta?.arg?.contractZoneId;
        state.priceClassLoading = false;
        let listOfPriceClasses = [];
        const transformPriceClasses = (data) => {
          return data?.map((item) => ({
            id: uuidv4(),
            contractId: item.contractPriceClass.contract_Id,
            priceClassId: item.contractPriceClass.price_Class_Id,
            name: item.priceClassName,
            factor: item.factor || 1,
            lastModifiedUserId: item.contractPriceClass.last_Modified_User_Id,
            lastModifiedTimestamp:
              item.contractPriceClass.last_Modified_Timestamp,
            prepaymentFlag: item.contractPriceClass.prepayment_Flag,
            prepaymentDurationDays:
              item.contractPriceClass.prepayment_Duration_Days,
            autoRenewFlag: item.contractPriceClass.auto_Renew_Flag,
            extendedServicesDurationDays:
              item.contractPriceClass.extended_Services_Duration_Days,
            effectiveDate: item.contractPriceClass.effective_Date,
            deferralServiceOfferingId:
              item.contractPriceClass.deferral_Service_Offering_Id,
            deferralServiceOfferingAddonId:
              item.contractPriceClass.deferral_Service_Offering_Addon_Id,
            isDeleted: false,
            contractZoneId: 1,
            // Add other properties as needed
          }));
        };
        let convertToSaveFormat = transformPriceClasses(
          action?.payload ? action?.payload.contractPriceClasses : []
        );
        convertToSaveFormat.forEach((item, index) => {
          let editeZoneTab = {
            ...priceClassList,
            isInserted: false,
            isDeleted: false,
            priceClassName: item.name,
            priceClassId: item.priceClassId,
            id: index,
            ...item,
          };
          listOfPriceClasses.push(editeZoneTab);
        });
        if (
          localSelectedZoneId !== CONTRACTS_DATA.extendedWarrentity.rentalZoneId
        ) {
          if (state.existingContractPriceClasses?.length === 0) {
            state.existingContractPriceClasses = listOfPriceClasses;
          }
        }

        const mydata = JSON.parse(JSON.stringify(state.warrantyPeriodTabData));
        if (
          localSelectedZoneId !== CONTRACTS_DATA.extendedWarrentity.rentalZoneId
        ) {
          state.warrantyPeriodTabData = mydata?.map((item) => {
            if (
              item?.contractZoneId !==
              CONTRACTS_DATA.extendedWarrentity.rentalZoneId
            ) {
              const newData = JSON.parse(JSON.stringify(listOfPriceClasses));
              item['priceClassList'] = newData?.map((priceClass) => {
                priceClass.contractZoneId = item?.contractZoneId;
                return priceClass;
              });
            }
            return item;
          });
        }
        if (
          localSelectedZoneId === CONTRACTS_DATA.extendedWarrentity.rentalZoneId
        ) {
          state.warrantyPeriodTabData = mydata?.map((item) => {
            if (
              item?.contractZoneId ===
              CONTRACTS_DATA.extendedWarrentity.rentalZoneId
            ) {
              const newData = JSON.parse(JSON.stringify(listOfPriceClasses));
              item['priceClassList'] = newData?.map((priceClass) => {
                priceClass.contractZoneId = item?.contractZoneId;
                return priceClass;
              });
            }
            return item;
          });
        }
      })
      .addCase(getContractPriceClasses.rejected, (state) => {
        state.priceClassLoading = false;
      })

      .addCase(getSelectedOptionsPriceClasses.pending, (state) => {
        state.selectedOptions_PriceClassSelection = [];
        state.selectedOptions_PriceClassesData = [];
        state.selectedOptionPriceClassesLoading = true;
        state.s_O_P_C_Datafound = false;
      })
      .addCase(getSelectedOptionsPriceClasses.fulfilled, (state, action) => {
        state.selectedOptions_PriceClassesData = action?.payload
          ? action?.payload?.contractPriceClasses?.map((item, i) => {
              item.contractPriceClass = {
                ...item.contractPriceClass,
                old_prepayment_Flag: item?.contractPriceClass?.prepayment_Flag,
                old_prepayment_Duration_Days:
                  item?.contractPriceClass?.prepayment_Duration_Days,
                old_auto_Renew_Flag: item?.contractPriceClass?.auto_Renew_Flag,
                old_extended_Services_Duration_Days:
                  item?.contractPriceClass?.extended_Services_Duration_Days,
                old_effective_Date: item?.contractPriceClass?.effective_Date,
                effective_Date_To_Save: null,
                old_deferral_Service_Offering_Id:
                  item?.contractPriceClass?.deferral_Service_Offering_Id,
                prepayment_Duration_Months: item?.prepayment_Duration_Months,
                extended_Services_Duration_Months:
                  item?.extended_Services_Duration_Months,
                old_prepayment_Duration_Months:
                  item?.prepayment_Duration_Months,
                old_extended_Services_Duration_Months:
                  item?.extended_Services_Duration_Months,
              };
              item.contractPriceClass['factor'] = item.factor;
              item.isChanged = false;
              item.PC_Index = i;
              item.priceClassId = item?.contractPriceClass?.price_Class_Id;
              item.priceClassSelectionTab = [];
              return item;
            })
          : [];
        state.selectedOptionPriceClassesLoading = false;
        state.s_O_P_C_Datafound = true;
      })
      .addCase(getSelectedOptionsPriceClasses.rejected, (state) => {
        state.selectedOptionPriceClassesLoading = false;
        state.s_O_P_C_Datafound = false;
      })

      .addCase(getPriceClassWithServices.pending, (state) => {
        state.priceClassSelectionTabLoader = true;
        state.selectedOptions_PriceClassSelection = [];
      })
      .addCase(getPriceClassWithServices.fulfilled, (state, action) => {
        let factor = action?.meta?.arg?.factor;
        let priceClassId = action?.meta?.arg?.priceClassId;
        state.priceClassSelectionTabLoader = false;
        state.selectedOptions_PriceClassSelection = action?.payload
          ? action?.payload?.contractPriceOptions?.filter(
              (zone) =>
                zone.contractZoneId !==
                CONTRACTS_DATA.extendedWarrentity.seasonalZoneId
            )
          : [];
        state.selectedOptions_PriceClassSelection?.map((item) => {
          item.old_selectedServiceOfferingId =
            item?.selectedServiceOfferingId || 0;
          item.old_serviceOfferingName =
            item?.services?.find(
              (so) =>
                so?.serviceOfferingId === item?.old_selectedServiceOfferingId
            )?.serviceOfferingName || '';
          item.isChanged = false;
          let selectedIndex = item?.services?.findIndex(
            (sItem) =>
              sItem?.serviceOfferingId === item?.selectedServiceOfferingId
          );
          item.selectedServiceOfferingIndex =
            selectedIndex !== -1 ? selectedIndex : 0;
          item.unId = uuidv4();
          item.factor = factor || 1;
          if (
            item?.contractFeeTypeId ===
            CONTRACTS_DATA.extendedWarrentity.warrantyPeriodFeeTypeId
          ) {
            item.contractFeeTypeName = CONTRACTS_DATA.warrantyPeriod;
          }
          if (
            item?.contractFeeTypeId ===
            CONTRACTS_DATA.extendedWarrentity.extServicePeriodFeeTypeId
          ) {
            item.contractFeeTypeName = CONTRACTS_DATA.extendedServicePeriod;
          }
          return convertZoneToPriceClass(item);
        });
        state.selectedOptions_PriceClassesData?.map((item) => {
          if (item.priceClassId === priceClassId) {
            item.priceClassSelectionTab =
              state.selectedOptions_PriceClassSelection;
            state.selectedPriceClassData.priceClassSelectionTab =
              state.selectedOptions_PriceClassSelection;
          }
          return item;
        });
      })
      .addCase(getPriceClassWithServices.rejected, (state, action) => {
        handleRejection(state, action);
        state.priceClassSelectionTabLoader = false;
        state.selectedOptions_PriceClassSelection = [];
      })

      .addCase(getContractServiceOfferings.pending, handlePending)
      .addCase(getContractServiceOfferings.fulfilled, (state, action) => {
        state.loading = false;
        state.existingContractServiceOfferings = action?.payload
          ?.contractServiceOfferings
          ? action?.payload?.contractServiceOfferings
          : [];
      })
      .addCase(getContractServiceOfferings.rejected, (state, action) => {
        handleRejection(state, action);
        state.existingContractServiceOfferings = [];
      })

      .addCase(updateSelectedOptions.pending, (state) => {
        state.apiSuccessResponse = {
          ...initialState.apiSuccessResponse,
          update: null,
        };
        state.isSelectedOptionsSave = false;
        state.isSelectedOptionsSaveSuccesfully = null;
        state.submitForApprovalSaveLoader = true;
      })
      .addCase(updateSelectedOptions.fulfilled, (state, action) => {
        state.loading = false;
        state.contractData = action?.meta?.arg || state.contractData;
        state.selectedOptionsSave = action?.payload;
        state.apiSuccessResponse = {
          ...initialState.apiSuccessResponse,
          update: true,
        };
        state.isSelectedOptionsSave = false;
        state.isSelectedOptionsSaveSuccesfully = true;
        state.submitForApprovalSaveLoader = false;
      })
      .addCase(updateSelectedOptions.rejected, (state) => {
        state.loading = false;
        state.apiSuccessResponse = {
          ...initialState.apiSuccessResponse,
          update: false,
        };
        state.isSelectedOptionsSave = false;
        state.isSelectedOptionsSaveSuccesfully = false;
        state.submitForApprovalSaveLoader = false;
      })

      .addCase(getContractBillSets.pending, handlePending)
      .addCase(getContractBillSets.fulfilled, (state, action) => {
        state.loading = false;
        state.contractBillSets = action?.payload;
      })
      .addCase(getContractBillSets.rejected, handleRejection)

      .addCase(getContractBillCycles.pending, handlePending)
      .addCase(getContractBillCycles.fulfilled, (state, action) => {
        state.loading = false;
        let cycleData = [];
        action?.payload?.map((item, index) => {
          cycleData.push(item || []);
          if (item?.description === null) {
            cycleData[index]['description'] = item?.name; //If Description is Null then storing Name value in Description
          }
        });

        state.contractBillCycles = cycleData || [];
      })
      .addCase(getContractBillCycles.rejected, handleRejection)

      .addCase(getDefaultPriceOptions.pending, (state) => {
        state.isPriceOptionsLoading = true;
        state.defaultPriceOptions = initialState.defaultPriceOptions;
        state.warrantyPeriodTabData = initialState.warrantyPeriodTabData;
      })
      .addCase(getDefaultPriceOptions.fulfilled, (state, action) => {
        state.warrantyPeriodTabData = [];
        state.isPriceOptionsLoading = false;
        let priceOptionList = [];
        PRICE_OPTIONS_DEFAULT_TAB.forEach((item) => {
          let editeZoneTab = {
            ...zoneTab,
            contractZoneId: item?.contractZoneId,
            contractZoneName: item?.contractZoneName,
            contractZoneNameDisplay: item?.contractZoneNameDisplay,
          };
          state.warrantyPeriodTabData.push(editeZoneTab);
        });
        state.defaultPriceOptions = action?.payload
          ? action?.payload?.filter(
              (zone) =>
                zone?.contractZoneId !==
                CONTRACTS_DATA.extendedWarrentity.seasonalZoneId
            )
          : [];
        if (state.defaultPriceOptions.length > 0) {
          state.defaultPriceOptions?.forEach((priceOption) => {
            priceOptionList.push(priceOption?.contractZoneId);
          });
          state.selectedZoneId = 1;
          const lastZoneId = Math.max(...priceOptionList);
          for (let i = 7; i <= lastZoneId; i++) {
            let editeZoneTab = {
              ...zoneTab,
              contractZoneId: i,
              contractZoneName:
                CONTRACTS_DATA.extendedWarrentity.zone + (i - 3),
              contractZoneNameDisplay:
                CONTRACTS_DATA.extendedWarrentity.priceOptionTabName + (i - 3),
            };
            state.warrantyPeriodTabData.push(editeZoneTab);
          }
          state.defaultPriceOptions?.map((priceOption) => {
            return convertZoneToPriceClass(priceOption);
          });
        }
      })
      .addCase(getDefaultPriceOptions.rejected, (state) => {
        state.isPriceOptionsLoading = false;
        state.defaultPriceOptions = initialState.defaultPriceOptions;
        state.warrantyPeriodTabData = initialState.warrantyPeriodTabData;
      })

      .addCase(fetchContractsSearchById.pending, (state) => {
        state.contractData = [];
        state.loading = true;
      })
      .addCase(fetchContractsSearchById.fulfilled, (state, action) => {
        state.loading = false;
        state.contractData = action?.payload ? action?.payload : [];
        state.contractId = action?.payload ? action?.payload?.contractId : 0;
      })
      .addCase(fetchContractsSearchById.rejected, (state, action) => {
        handleRejection(state, action);
        state.contractData = [];
        state.loading = false;
        state.contractId = 0;
      })

      .addCase(selectedOptionDefferalServiceOffering.pending, (state) => {
        state.selectedOpDefServiceOffering = [];
        state.SODefServiceOfferingLoading = true;
      })
      .addCase(
        selectedOptionDefferalServiceOffering.fulfilled,
        (state, action) => {
          state.selectedOpDefServiceOffering = action?.payload
            ? action?.payload
            : [];
          state.SODefServiceOfferingLoading = false;
        }
      )
      .addCase(
        selectedOptionDefferalServiceOffering.rejected,
        (state, action) => {
          handleRejection(state, action);
          state.selectedOpDefServiceOffering = [];
          state.SODefServiceOfferingLoading = false;
        }
      )

      .addCase(trickleDownContractChange.pending, (state) => {
        state.trickleDownAPIResponse = null;
        state.trickleDownLoading = true;
        state.isTDSuccess = null;
      })
      .addCase(trickleDownContractChange.fulfilled, (state, action) => {
        state.trickleDownAPIResponse = action?.payload ? action?.payload : null;
        state.trickleDownLoading = false;
        state.isTDSuccess = true;
      })
      .addCase(trickleDownContractChange.rejected, (state, action) => {
        state.trickleDownAPIResponse = action?.payload.response.data
          ? action?.payload.response.data
          : null;
        state.trickleDownLoading = false;
        state.isTDSuccess = false;
      })

      .addCase(updatePriceClassOptionsTab.pending, handlePending)
      .addCase(updatePriceClassOptionsTab.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(updatePriceClassOptionsTab.rejected, handleRejection);
  },
});

export const {
  addPriceClassData,
  handleSetContractTabValue,
  handlePriceClassessearch,
  handleSelectedPriceClasses,
  handleSelectedPriclassesData,
  handleSetAnnualFeeService,
  handleRentalAnnualFeeAdd,
  handleManualContractData,
  handleDeferralPriceclassAlert,
  handleSelectedPriceOptions,
  handleSlectedOptionsForm,
  handleSlectedOptionsExistingData,
  handleContractStartDateChange,
  handleContractEndDateChange,
  handleContractDetailsForm,
  handleBillingForm,
  handleOosForm,
  handleWarrantyForm,
  handleEtrackForm,
  handleContractSaveClose,
  handleResetValues,
  setAPIResponse,
  handleChangeClick,
  handleResetSelectedOptionTab,
  handleSetSelectedPriceOptionTab,
  handleAddNewPriceOption,
  handleAddDeferralPriceClass,
  handleRemoveDeferralPriceClass,
  selectedServiceOffering,
  handleClosePriceClassAlreadyAdded,
  handleIsDataToSave,
  handleReset_PC_and_SO_WP_ES_Tab,
  handleSetSaveAndClose,
  handleSetContractId,
  handleCpiForm,
  handleSelectedOptionAlertText,
  handleSelectedOptionAlert,
  handleTrickleDownFlags,
  handleIsTrickleDown,
  handleUpdateContracData,
  resetIsEditedSelectedOption,
  handleReadyForApproveOnClose,
  handleUpdatePCOptions,
  handleWarr_ExSer_APIResponse,
  handleOnAlertSave,
  handleSelectedPC,
  handleSelectedPCDeleted,
} = warrantyPeriodSlice.actions;
export default warrantyPeriodSlice.reducer;
